import { RootState } from "../types";

export const chatConnectionSelector = (state: RootState) =>
  state.chat.connection;
export const chatUsersSelector = (state: RootState) => state.chat.chatUsers;
export const callEndedSelector = (state: RootState) => state.chat.callEnded;
export const chatStateSelector = (state: RootState) => state.chat;
export const showAppointmentEndPopupSelector = (state: RootState) =>
  state.chat.showAppointmentEndPopup;
export const connectionErrorSelector = (state: RootState) =>
  state.chat.connectionError;
export const currentUserIdSelector = (state: RootState) =>
  state.chat.currentUserId;
